<div id="announcement-bar"
  class="bg-red-500 text-white text-center px-3 py-1 sticky top-0 z-50 flex justify-between items-center">
  <p class="font-medium flex-grow whitespace-nowrap">Unlock free gift & claim your offer <span (click)="claimOffer()"
      class="underline cursor-pointer font-semibold"> Click Here </span></p>
</div>

<div *ngIf="isModalOpen" class="fixed inset-0 bg-gray-600 bg-opacity-70 flex items-start justify-center z-50">
  <div class="sticky top-5 mt-10 md:mt-10 w-full max-w-lg mx-auto border shadow-lg rounded-md bg-white md:w-2/5">
    <div *ngIf="!detailsSubmitted" class="text-center pb-6">
      <div class="bg-gray-200 p-2 rounded-t-md flex flex-col items-center justify-center">
        <div class="self-end">
          <i class='bx bx-x-circle cursor-pointer text-3xl text-gray-400' (click)="closeForm()"></i>
        </div>
        <img src="../../../../../assets/images/store/offers-png.png" alt="" srcset="" class="h-auto w-1/4 py-3">
      </div>
      <span class="text-2xl leading-6 font-medium text-gray-900 pt-8 block">Unlock Your Free Gift and Savings!</span>
      <div class="mt-2 px-7 py-3">
        <span class="text-md block">Enter your details below to claim your offer</span>
        <form (ngSubmit)="submitForm()" class="mt-4">
          <div class="flex items-center gap-2">
            <i class='bx bxs-user text-2xl'></i>
            <input [(ngModel)]="formData.name" name="name" type="text" placeholder="Name"
              class="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
          </div>
          <div class="flex items-end gap-2">
            <i class='bx bxs-phone text-2xl'></i>
            <input [(ngModel)]="formData.mobile" name="mobile" type="text" placeholder="Mobile Number"
              class="mt-4 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
          </div>
          <div class="flex items-center gap-2">
            <i class='bx bxs-envelope text-2xl'></i>
            <input [(ngModel)]="formData.email" name="email" type="email" placeholder="Email"
              class="mt-4 mb-4 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
          </div>
          <button type="submit" [disabled]="!isFormValid()"
            class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none sm:text-sm">
            Continue
          </button>

        </form>
      </div>
    </div>
    <div *ngIf="detailsSubmitted" class="text-center pb-6">
      <div class="bg-gray-200 p-2 rounded-t-md flex flex-col items-center justify-center">
        <div class="self-end">
          <i class='bx bx-x-circle cursor-pointer text-3xl text-gray-400' (click)="closeForm()"></i>
        </div>
        <img src="../../../../../assets/images/store/otp-verification.png" alt="" srcset="" class="h-auto w-1/4 py-3">
      </div>
      <span class="text-2xl leading-6 font-medium text-gray-900 pt-8 block">OTP Verification</span>
      <div class="mt-2 px-7 py-3">
        <span class="text-md text-gray-400 block">A 4 digit code has been sent to your mobile number</span>

        <div class="d-flex justify-content-center align-items-center mt-5 gap-2">
          <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{
                            length: 4,
                            allowNumbersOnly: true,
                            inputStyles: { outline: 0,color:'grey' }
                          }"></ng-otp-input>
        </div>

        <div class="text-center mt-5">
          <span class="d-block mobile-text text-l">
            Code Not Recieved ?
          </span>
          <span (click)="resendOTP()" class="font-bold text-red-600 text-l cursor-pointer">Resend Code</span>
        </div>

      </div>
    </div>
  </div>
</div>